import React, { useEffect, useState} from 'react'
import { ateliersFields, zonesFields } from '../../utils/adminFieldData'
import { createAtelier, createZone, fetchAteliers, 
  fetchZones, updateAtelier, updateZone, deleteAtelier, 
  deleteZone} from '../../redux/reservationSlice'
import { useDispatch, useSelector } from 'react-redux'
import AdminData from './adminLocalComponents/AdminData'
import { v4 as uuid } from 'uuid'

function AdminLocal() {

  const reservation = useSelector((state)=> state.reservation)

  const [sectionSelect, setSectionSelect] = useState( { 
      titre: 'ateliers', 
      colonnes: ateliersFields,
      actionCreate: createAtelier,
      data: reservation.ateliers,
      fetchData: fetchAteliers,
      actionEdit: updateAtelier,
      actionDelete: deleteAtelier,
    })

  const [dataDisplayAdminLocal, setDataDisplayAdminLocal] = useState([
    { 
      titre: 'ateliers', 
      colonnes: ateliersFields,
      actionCreate: createAtelier,
      data: reservation.ateliers,
      fetchData: fetchAteliers,
      actionEdit: updateAtelier,
      actionDelete: deleteAtelier,
    },
    { 
      titre: 'zones', 
      colonnes: zonesFields,
      actionCreate: createZone,
      data: reservation.zones,
      fetchData: fetchZones,
      actionEdit: updateZone,
      actionDelete: deleteZone
    },
    {name: 'Tables', composant: <div></div>},
    {name: 'Periodes', composant: <div></div>}]
  );
 
  const handlerSelection = (item) => {
    setSectionSelect(item)
  }

  useEffect(()=>{
    dataDisplayAdminLocal.map(item => {
      item.data = reservation[item.titre]
    })
  },[reservation])

  return (
    <div className='mx-5'>
        <div className='flex flex-row gap-8 my-5 mx-2'>
          { dataDisplayAdminLocal.map((item) => (
            <button 
            className="bg-orange-400 text-white px-6 py-2 rounded-xl hover:bg-orange-600 transition"
            onClick={()=>handlerSelection(item)}>
              {item.titre}
           </button>
          ))}
        </div>

        <div>
           <AdminData key={uuid()} {...sectionSelect}/>
        </div>
    </div>
  )
}

export default AdminLocal